import clsx from 'clsx';
import React from 'react';

const pillVariantClasses = {
  danger: 'bg-dangerLight text-dark',
  primary: 'bg-primary text-white',
  secondary: 'bg-cloud text-secondary',
  success: 'bg-success/10 text-success',
} as const;

const circleVariantClasses = {
  danger: 'bg-danger text-white',
  primary: 'bg-electric text-white',
  secondary: 'bg-waves text-white',
  success: 'bg-success text-white',
} as const;

const shapeClasses = {
  pill: 'inline-flex items-center gap-1 rounded-full h-7 p-2 text-base font-medium whitespace-nowrap',
  circle:
    'inline-flex items-center justify-center rounded-full w-7 h-7 p-1 text-sm leading-none font-semibold shrink-0',
} as const;

export interface BadgeProps
  extends Omit<React.HTMLAttributes<HTMLSpanElement>, 'className'> {
  shape?: keyof typeof shapeClasses;
  variant?: keyof typeof pillVariantClasses;
  icon?: React.ReactNode;
  className?: string;
}

const Badge = React.forwardRef<HTMLSpanElement, BadgeProps>(
  (
    {
      shape = 'pill',
      variant = 'primary',
      icon,
      className = '',
      children,
      ...spanProps
    },
    ref
  ) => {
    const variantClasses =
      shape === 'circle' ? circleVariantClasses : pillVariantClasses;

    return (
      <span
        ref={ref}
        className={clsx(
          shapeClasses[shape],
          variantClasses[variant],
          className
        )}
        {...spanProps}
      >
        {shape === 'pill' && icon && (
          <span className="shrink-0 [&>svg]:w-4 [&>svg]:h-4">{icon}</span>
        )}
        {children}
      </span>
    );
  }
);

Badge.displayName = 'Badge';

export default Badge;
